import { MDCFormField } from '@material/form-field'
import { MDCCheckbox } from '@material/checkbox'

export default {
  setup() {
    this.checkbox = new MDCCheckbox(this.el.querySelector('.mdc-checkbox'))
    this.formField = new MDCFormField(this.el)
    this.formField.input = this.checkbox
  },
  destroy() {
    this.formField?.destroy()
    this.formField = null
    this.checkbox?.destroy()
    this.checkbox = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
